import { AbstractJSONModel } from "../models/master-model";

export interface IInfoCenterItem {
  category: string;
  categoryIcon: string;
  time: Date;
  title: string;
  titleIcon: string;
  subtitle: string;
  onClick: Function | null;
}

export class InfoCenterItem extends AbstractJSONModel implements IInfoCenterItem {
  category = "";
  categoryIcon = "mdi-message";
  time: Date = new Date();
  title = "";
  titleIcon = "mdi-open-in-app";
  subtitle = "";
  onClick: Function | null = null;
}
